export default function RewardIcon({ className }: any) {
  return (
    <svg className={className} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 9.58398C3 8.64118 3 8.16977 3.29289 7.87688C3.58579 7.58398 4.05719 7.58398 5 7.58398H17.5C18.4428 7.58398 18.9142 7.58398 19.2071 7.87688C19.5 8.16977 19.5 8.64118 19.5 9.58398V10.7923C19.5 11.1412 19.5 11.3157 19.4569 11.4576C19.36 11.7772 19.1099 12.0273 18.7903 12.1243C18.6483 12.1673 18.4739 12.1673 18.125 12.1673V12.1673C17.7761 12.1673 17.6017 12.1673 17.4597 12.2104C17.1401 12.3073 16.89 12.5574 16.7931 12.877C16.75 13.019 16.75 13.1934 16.75 13.5423V16.584C16.75 17.5268 16.75 17.9982 16.4571 18.2911C16.1642 18.584 15.6928 18.584 14.75 18.584H7.75C6.80719 18.584 6.33579 18.584 6.04289 18.2911C5.75 17.9982 5.75 17.5268 5.75 16.584V13.5423C5.75 13.1934 5.75 13.019 5.70694 12.877C5.60999 12.5574 5.35989 12.3073 5.04028 12.2104C4.89834 12.1673 4.72389 12.1673 4.375 12.1673V12.1673C4.02611 12.1673 3.85166 12.1673 3.70972 12.1243C3.39011 12.0273 3.14001 11.7772 3.04306 11.4576C3 11.3157 3 11.1412 3 10.7923V9.58398Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M4.83301 12.166H17.6663" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M11.25 6.66602L11.25 18.5827" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M11.2497 6.66667L10.4443 5.86132C9.46688 4.88388 8.27528 4.14742 6.96389 3.7103V3.7103C5.91558 3.36086 4.83301 4.14113 4.83301 5.24615V5.41308C4.83301 6.16171 5.31205 6.82635 6.02226 7.06308L7.58301 7.58333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.2503 6.66667L12.0557 5.86132C13.0331 4.88388 14.2247 4.14742 15.5361 3.7103V3.7103C16.5844 3.36086 17.667 4.14113 17.667 5.24615V5.41308C17.667 6.16171 17.1879 6.82635 16.4777 7.06308L14.917 7.58333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
